/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_seo_rg_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Random number & UUID generator`)
};

const es_home_seo_rg_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador de números aleatorios y UUID`)
};

const de_home_seo_rg_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zufallszahlengenerator & UUID-Generator`)
};

const nl_home_seo_rg_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generator voor willekeurige nummers en UUID`)
};

const fr_home_seo_rg_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générateur de nombres aléatoires et UUID`)
};

const it_home_seo_rg_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatore di numeri casuali e UUID`)
};

const pt_br2_home_seo_rg_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de números aleatórios e UUID`)
};

const pt_home_seo_rg_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de números aleatórios e UUID`)
};

const ja_home_seo_rg_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ランダム番号とUUIDジェネレータ`)
};

const zh_home_seo_rg_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`随机数与UUID生成器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_seo_rg_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_seo_rg_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_seo_rg_title", locale)
	if (locale === "en") return en_home_seo_rg_title(inputs)
	if (locale === "es") return es_home_seo_rg_title(inputs)
	if (locale === "de") return de_home_seo_rg_title(inputs)
	if (locale === "nl") return nl_home_seo_rg_title(inputs)
	if (locale === "fr") return fr_home_seo_rg_title(inputs)
	if (locale === "it") return it_home_seo_rg_title(inputs)
	if (locale === "pt-BR") return pt_br2_home_seo_rg_title(inputs)
	if (locale === "pt") return pt_home_seo_rg_title(inputs)
	if (locale === "ja") return ja_home_seo_rg_title(inputs)
	return zh_home_seo_rg_title(inputs)
};